var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36914 10.5286V11.6953C2.36914 12.0047 2.49206 12.3015 2.71085 12.5203C2.92964 12.7391 3.22639 12.862 3.53581 12.862H10.5358C10.8452 12.862 11.142 12.7391 11.3608 12.5203C11.5796 12.3015 11.7025 12.0047 11.7025 11.6953V10.5286M4.11914 7.02865L7.03581 9.94531M7.03581 9.94531L9.95247 7.02865M7.03581 9.94531V2.94531",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/download_button.7abedaac545fc25983c375de92b9180f.svg";
export { ForwardRef as ReactComponent };